import { ReactNode } from 'react'
import i18n from 'translations/i18n'
import { Button, FeaturedIcon, Flex, Spacer, Typography } from '@jisr-hr/ds'
import { required } from 'components/global/form/FormValidations'
import { Form } from 'react-final-form'
import { TextInputField } from 'components/final-form'
import { Modal } from '@jisr-hr/design-system'
import { useDispatch, useSelector } from 'utils/hooks'
import {
  requestChangePassword,
  TChangePassword,
} from 'redux/authUser/changePassword/actionCreators'
import { isEmpty } from 'lodash'

type ChangePasswordFormProps = {
  data: {
    login: string // username
    password: string
  }
  onClose: () => void
}

const ChangePasswordForm = ({ data, onClose }: ChangePasswordFormProps): ReactNode => {
  const { fetching } = useSelector((state) => state.changePassword)
  const dispatch = useDispatch()

  const onSubmit = (values: TChangePassword): void => {
    dispatch(
      requestChangePassword({
        ...values,
        login: data.login,
        old_password: data.password,
      }),
    ).then(() => {
      onClose()
    })
  }

  return (
    <div>
      <Modal
        variant="centerDialog"
        isOpen={!isEmpty(data)}
        onClose={onClose}
        width={480}
      >
        <Flex style={{ gap: 8, padding: '20px 16px' }}>
          <div>
            <FeaturedIcon
              colorType="gray-dark"
              iconName="info-circle"
              size="sm"
            />
          </div>
          <div className="header">
            <Typography
              variant="heading"
              textColor="color/fg/bold"
              text={i18n.t('label.create_new_password_to_continue')}
            />
            <Spacer height={8} />
            <Typography
              variant="body-new/regular"
              textColor="color/fg/bold"
              text={i18n.t('description.new_password_creation_description')}
            />
            <Spacer height={24} />
            <Form
              onSubmit={onSubmit}
              render={({ handleSubmit }): ReactNode => (
                <form onSubmit={handleSubmit}>
                  <div style={{ maxWidth: 353 }}>
                    {/* @ts-expect-error Need to migrate TextInputField.js to TypeScript */}
                    <TextInputField
                      name="password"
                      type="password"
                      autoFocus
                      label={i18n.t('label.new_password')}
                      validate={required}
                    />
                    <Spacer height={12} />
                    {/* @ts-expect-error Need to migrate TextInputField.js to TypeScript */}
                    <TextInputField
                      name="password_confirmation"
                      type="password"
                      validate={required}
                      label={i18n.t('label.confirm_password')}
                    />
                  </div>
                  <Spacer height={32} />
                  <Flex
                    style={{ gap: 8 }}
                    itemsCenter
                    justifyEnd
                  >
                    <Button
                      label={i18n.t('label.cancel')}
                      type="button"
                      variant="secondary"
                      onClick={onClose}
                    />
                    <Button
                      label={i18n.t('label.create_password')}
                      type="submit"
                      disabled={fetching}
                    />
                  </Flex>
                </form>
              )}
            />
          </div>
        </Flex>
      </Modal>
    </div>
  )
}

export default ChangePasswordForm
